var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-form-input',{attrs:{"placeholder":_vm.placeholder,"autocomplete":"off"},model:{value:(_vm.iban),callback:function ($$v) {_vm.iban=$$v},expression:"iban"}})
}
var staticRenderFns = []

export { render, staticRenderFns }